import { homeConstants } from "../constants";

export default function (
  state = {
    isProgress: false,
    data: {},
    error: "",
    message: "",
  },
  action
) {
  switch (action.type) {
    case homeConstants.RETAIL_PRICE_REQUEST:
      return {
        ...state,
        isProgress: true,
        message: "",
        error: null,
      };
    case homeConstants.RETAIL_PRICE_UPDATE:
      return {
        ...state,
        data: action.data,
      };
    case homeConstants.RETAIL_PRICE_SUCCESS:
      return {
        data: action.response.data,
        isProgress: false,
        message: action.response.message,
        success: action.response.success,
        error: null,
      };
    case homeConstants.RETAIL_PRICE_FAILURE:
      return {
        data: {},
        error: action.error,
        isProgress: false,
        success: false,
      };
    case homeConstants.RESET_DATA:
      return {
        ...state,
        data: {},
        message: "",
        error: null,
      };
    default:
      return state;
  }
}
